// Funções para processar dados dos gráficos de Contas a Receber

export const processarDadosGraficoDia = (contas) => {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  
  // Separar contas vencidas e não vencidas
  const contasVencidas = contas.filter(conta => conta.status === 'vencida');
  const contasNaoVencidas = contas.filter(conta => conta.status !== 'vencida');
  
  // Encontrar o dia mais próximo (não vencido) a partir de hoje
  let primeiroDiaComContas = null;
  let menorDiferencaDias = Infinity;
  
  contasNaoVencidas.forEach(conta => {
    const baseDate = conta.data_vencimento_convertida || conta.dataVencimento;
    if (!baseDate) return;
    const vencimento = new Date(baseDate);
    vencimento.setHours(0, 0, 0, 0);
    
    if (!isNaN(vencimento.getTime())) {
      const diferencaDias = Math.ceil((vencimento - hoje) / (1000 * 60 * 60 * 24));
      
      // Se a conta não está vencida (diferencaDias >= 0) e é mais próxima
      if (diferencaDias >= 0 && diferencaDias < menorDiferencaDias) {
        menorDiferencaDias = diferencaDias;
        const diaSemana = vencimento.getDay(); // 0 = domingo, 1 = segunda, etc.
        primeiroDiaComContas = diaSemana === 0 ? 6 : diaSemana - 1; // Ajustar para começar na segunda
      }
    }
  });
  
  // Se não há contas não vencidas, usar o dia atual
  if (primeiroDiaComContas === null) {
    const diaAtual = hoje.getDay();
    primeiroDiaComContas = diaAtual === 0 ? 6 : diaAtual - 1; // Ajustar para começar na segunda
  }
  
  // Criar array de dias ordenado começando pelo primeiro dia com contas
  const diasSemana = ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB', 'DOM'];
  const dados = [];
  
  // Adicionar dias a partir do primeiro dia com contas
  for (let i = 0; i < 7; i++) {
    const indice = (primeiroDiaComContas + i) % 7;
    dados.push({ 
      dia: diasSemana[indice], 
      valor: 0,
      contas: 0,
      indiceOriginal: indice 
    });
  }
  
  // Processar contas não vencidas
  contasNaoVencidas.forEach(conta => {
    const baseDate = conta.data_vencimento_convertida || conta.dataVencimento;
    if (!baseDate) return;
    const vencimento = new Date(baseDate);
    vencimento.setHours(0, 0, 0, 0);
    
    if (!isNaN(vencimento.getTime())) {
      const diaSemana = vencimento.getDay();
      const indice = diaSemana === 0 ? 6 : diaSemana - 1;
      
      // Encontrar a posição no array ordenado
      const posicao = dados.findIndex(d => d.indiceOriginal === indice);
      if (posicao !== -1) {
        dados[posicao].valor += parseFloat(conta.valor) || 0;
        dados[posicao].contas += 1;
      }
    }
  });
  
  // Agregar todas as contas vencidas no primeiro dia
  const totalVencidas = contasVencidas.reduce((sum, conta) => sum + (parseFloat(conta.valor) || 0), 0);
  if (totalVencidas > 0) {
    dados[0].valor += totalVencidas;
    dados[0].contas += contasVencidas.length;
  }
  
  return dados;
};

export const processarDadosGraficoMes = (contas) => {
  // Agrupar dinamicamente por mês/ano com base nos dados recebidos
  const dadosMap = new Map();

  contas.forEach(conta => {
    const baseDate = conta.data_vencimento_convertida || conta.dataVencimento;
    if (!baseDate) return;
    const venc = new Date(baseDate);
    if (isNaN(venc)) return;

    const key = `${venc.getFullYear()}-${String(venc.getMonth() + 1).padStart(2, '0')}`;
    const label = venc.toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' }).toUpperCase();
    const valor = parseFloat(conta.valor) || 0;

    if (!dadosMap.has(key)) {
      dadosMap.set(key, { mes: label, valor: 0, contas: 0, _order: venc.getTime() });
    }
    const item = dadosMap.get(key);
    item.valor += valor;
    item.contas += 1;
  });

  return Array.from(dadosMap.values())
    .sort((a, b) => a._order - b._order)
    .map(({ _order, ...rest }) => rest);
};

